import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  TextField
} from "@mui/material";
import NewHeader from "../../layouts/dashboard/header/NewHeader";
import Breadcrumb from "../../pages/VendorDetail/Breadcrumb.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CrossImg from "../../assets/cross-select.svg";
import { useSnackbar } from "notistack";
import GetRequest from "../../components/apiConnections/getRequest.js";
import CalendarTodayIcon from '../../assets/calender-icon-select.svg';
import moment from "moment";
import PostRequest from "../../components/apiConnections/postRequest.js";
import { useLocation } from "react-router-dom";
import Loader from "../../Loader.js";
import ProfileCyber from "../../assets/cyber-security.png";
const style = {
  position: "absolute",
  background: '#120A3A',
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  boxShadow: 24,
  maxHeight: "586px", // Set maximum height for scrolling
  overflowY: "auto",  // Enable vertical scrolling
};
function CVEDetail() {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [contactPersonList, setContactPersonList] = useState([]);
  const [openCreateRemediation, setOpenCreateRemediation] = React.useState(false);
  const handleOpenCreateRemediation = (key) => {
    getVendorContactPerson(key?.domain);
    setFormValues({
      issueId: selectedCVE?.issueId || '-',
      name: selectedCVE?.issueName || "",
      description: selectedCVE?.description || "",
      url: (key?.url && key?.url?.length) ? key?.url?.join('\r\n') || "" : "",
      remediation: selectedCVE?.remediation || "",
      severity: selectedCVE?.severity,
      deadline: "",
      remark: ""
    });
    setOpenCreateRemediation(true);
  }
  const handleCloseCreateRemediation = () => {
    setOpenCreateRemediation(false);
    setSelectedContactPerson("");
    setFormValues({});
  }
  const [selectedContactPerson, setSelectedContactPerson] = useState("");
  const [loading, setLoading] = useState(false);
  const CVEData = location?.state?.issueData;
  const selectedCVE = location?.state?.issueData;
  let clientId = localStorage.getItem("userId")
  const issueID = location?.state?.issueData?.issueId;
  const [remediationStaus, setRemediationStaus] = useState([]);

  const [formValues, setFormValues] = useState({
    issueId: selectedCVE?.issueId || '-',
    name: selectedCVE?.issueName || "",
    description: selectedCVE?.description || "",
    remediation: selectedCVE?.remediation || "",
    severity: selectedCVE?.severity || "-",
    deadline: "",
    remark: ""
  });
  const breadcrumbs = [
    { label: "CVE", path: "/dashboard/vulnerability", mainTabValue: "2" },
    { label: "Vulnerability Detail" },
  ];
  const [activeTab, setActiveTab] = useState(null);
  const toggleTab = (tabName) => {
    setActiveTab((prevTab) => (prevTab === tabName ? null : tabName));
  };
  useEffect(() => {
    getRemediationStatus();
  }, [CVEData]);

  const getVendorContactPerson = async (domain) => {
    try {
      GetRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_GET_DOMAIN_CONTACT_PERSON}?domain=${domain}`
      )
        .then((res) => {
          const obj2 = res.data.data;
          setContactPersonList(obj2);
        })
        .catch((err) => {
          // no data
          enqueueSnackbar("Contact person not found", { variant: "error" });
          return false;
        });
    } catch (error) {
      // no data
      enqueueSnackbar("Contact person not found", { variant: "error" });
      return false;
    }
  };
  const sendRemediation = (event) => {
    event.preventDefault();
    const contactPerson = JSON.parse(selectedContactPerson || "{}");
    if (!validateForm(formValues, contactPerson)) {
      return;  // Stop execution if validation fails
    }
    setLoading(true);
    const payload = {
      uniqueId: uniqueIdGenerator(contactPerson),
      firstName: contactPerson?.firstName,
      lastName: contactPerson?.lastName,
      email: contactPerson?.email,
      deadline: formValues.deadline,
      createdBy: localStorage.getItem("userEmail"),
      url: contactPerson?.vendorDomain,
      remediationType: "forIssue",
      issueId: formValues?.issueId,
      issueRemediationPlan: {
        description: formValues.description,
        issueName: formValues.name,
        remark: formValues.remark,
        url: formValues?.url?.split('\n').join(','),
        severity: formValues.severity
      },
      severity: formValues.severity
    }
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_SEND_REMEDIATION_BY_USER}`;
    PostRequest(url, payload)
      .then((response) => {
        enqueueSnackbar(response.data.message, { variant: "success" });
        setLoading(false);
        getRemediationStatus();
        handleCloseCreateRemediation();
      })
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
        setLoading(false);
      });
  }
  const handleContactPersonChange = (e) => {
    setSelectedContactPerson(e.target.value);
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const validateForm = (formValues, contactPerson) => {
    if (!formValues.deadline || formValues.deadline.trim() === "") {
      enqueueSnackbar("Please select deadline.", { variant: "error" });
      return false;
    }
    if (!contactPerson?.email || contactPerson?.email.trim() === "") {
      enqueueSnackbar("Please select a valid contact person.", { variant: "error" });
      return false;
    }
    if (!formValues.description || formValues.description.trim() === "") {
      enqueueSnackbar("Please provide a valid description.", { variant: "error" });
      return false;
    }
    if (!formValues.name || formValues.name.trim() === "") {
      enqueueSnackbar("Please provide a valid issue name.", { variant: "error" });
      return false;
    }
    // if (!formValues.remark || formValues.remark.trim() === "") {
    //   enqueueSnackbar("Please provide a valid remark.", { variant: "error" });
    //   return false;
    // }
    if (!formValues.url || Array.isArray(formValues.url) || formValues.url.length === 0) {
      enqueueSnackbar("Please provide a valid URL list.", { variant: "error" });
      return false;
    }
    return true;
  };
  const getCurrentDate = (date) => {
    let parseDate = moment(date).add(1, 'day');
    let currentDate = new Date(parseDate);
    let year = currentDate.getFullYear();
    let month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    let day = currentDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const uniqueIdGenerator = (contactPerson) => {
    function generateSixDigitAlphanumeric() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#';
      let result = '';
      for (let i = 0; i < 6; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    }
    let alphaNumericId = generateSixDigitAlphanumeric();
    let uniqueId = `REM-${alphaNumericId}`;
    return uniqueId;
  }
  const getSeverityTag = (tag) => {
    let cssClass;
    if (tag.toUpperCase() === 'CRITICAL') {
      cssClass = "Critical";
    } else if (tag.toUpperCase() === 'HIGH') {
      cssClass = "High";
    } else if (tag.toUpperCase() === 'MEDIUM') {
      cssClass = "Medium";
    } else if (tag.toUpperCase() === 'LOW') {
      cssClass = "Low";
    }
    return cssClass;
  }
  const getRemediationStatus = () => {
    try {
      GetRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_GET_REMEDIATION_STATUS}?clientId=${clientId}&issueId=${issueID}`
      )
        .then((res) => {
          const obj2 = res.data?.data;
          setRemediationStaus(obj2)
        })
        .catch((err) => {
          return false;
        });
    } catch (error) {
      return false;
    }
  };
  const getStatus = (vendorName) => {
    const matchedVendor = Array.isArray(remediationStaus) && remediationStaus?.find((item) => item.url === vendorName);
    return matchedVendor ? matchedVendor?.isPending : null;
  };

  return (
    <>
      <Loader show={loading} />
      <Helmet>
        <title> Vulnerability | Genesis Platform</title>
      </Helmet>
      <Container maxWidth={false} className="max-w-left">
        <NewHeader titleName="Vulnerability CVE Detail" />
        <Grid container spacing={3} className="ipad-space">
          <Grid item xs={12} md={12} lg={12}>
            <div className="security-breadcum">
              <div>
                <Breadcrumb crumbs={breadcrumbs} />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <div className="vulnerability-flex-detail">
              <div>
                <h3>Name</h3>
                <h4>{CVEData?.issueName || '-'}</h4>
              </div>
              <div>
                <h3>Score</h3>
                <h4>{CVEData?.score !== 'null' ? CVEData?.score : "-"}</h4>
              </div>
              <div>
                <h3>Severity</h3>
                <h4>
                  <span className={`tagClass ${getSeverityTag(CVEData?.severity)}`}>{CVEData?.severity !== 'null' ? getSeverityTag(CVEData?.severity) : "-"}</span>
                </h4>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <div className="bg-dark-detail">
              <div className="discriptions-vulnerability-text">
                <h3>Technology</h3>
                <p>{CVEData?.technology || '-'}</p>
              </div>
              <div className="discriptions-vulnerability-text">
                <h3>CPE</h3>
                <p>{CVEData?.CPE || '-'}</p>
              </div>
              <div className="discriptions-vulnerability-text">
                <h3>CWE</h3>
                <p>{CVEData?.CWE || '-'}</p>
              </div>
              <div className="discriptions-vulnerability-text">
                <h3>Description</h3>
                <p>{CVEData?.description || '-'}</p>
              </div>
              <div className="discriptions-vulnerability-text">
                <h3>Remediation</h3>
                <p>{CVEData?.remediation || '-'}</p>
              </div>
              <div className="discriptions-vulnerability-text">
                <h3>Advisory Link</h3>
                {CVEData?.references?.map((link, i) => (
                  <p link={i}> #{i + 1}
                    <a style={{ color: "white", marginLeft: "15px" }}
                      href={link.startsWith("http://") || link.startsWith("https://")
                        ? link : `http://${link}`
                      }
                      target="_blank"
                      rel="noopener noreferrer"> {link}</a>
                  </p>
                ))}

              </div>
              <div className="accordion-item">
                <h4 className="accordion-header issues-related-detail-line">
                  <div className="commet-line"><span>Affected Vendors</span></div>
                </h4>
              </div>
              {/*  */}
              {CVEData?.domains?.map((key, i) => (
                <div className="accordion-item" key={i}  >
                  <h4 onClick={() => toggleTab(i)} className="accordion-header issues-related-detail-line">
                    {/* Left Section - Logo + Domain */}
                    <div className="domain-section">
                      <span className="logo-image-vendor">
                        <img
                          className="attack-surface-list-logo"
                          src={`${key.logo}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = ProfileCyber;
                          }}
                          alt="logo"
                        />
                      </span>
                      <span className="domain-name">
                        {key?.domain.split('.')[0].replace(/\b\w/g, (char) => char.toUpperCase())}
                      </span>
                    </div>
                    {/* Center Section - Status (Now Aligned Correctly) */}
                    <div className="status-section">
                      <span>Status:</span>
                      {remediationStaus && remediationStaus.length > 0 ? (
                        <span
                          className={`${getStatus(key?.domain) === true ? "Pending" : getStatus(key?.domain) === false ? "Fixed" : 'ToSent'}`}
                          key={i}
                        >
                          {getStatus(key?.domain) === true ? "Pending" : getStatus(key?.domain) === false ? "Fixed" : '-'}
                        </span>
                      ) : (
                        "-"
                      )}
                    </div>
                    <div className="accordion-icon">
                      <span className="create-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenCreateRemediation(key);
                        }}
                      > + Create </span>
                    </div>
                    <div className="accordion-icon">
                      {activeTab === i ? <ExpandLessIcon /> : < ExpandMoreIcon />}
                    </div>
                  </h4>
                  {activeTab === i && (
                    <div className="accordion-content">
                      <div className="discriptions-vulnerability-text">
                        {key?.url && key?.url?.length ?
                          <>{key?.url?.map((key1, i) => (
                            <p key={i}> # {i + 1}
                              <a style={{ color: "white", marginLeft: "15px" }}
                                href={key1.startsWith("http://") || key1.startsWith("http://") ? key1 : `http://${key1}`}
                                target="_blank"
                                rel="noopener noreferrer">
                                {key1.startsWith("http://") || key1.startsWith("http://") ? key1 : `http://${key1}`}
                              </a>
                            </p>
                          ))}</>
                          :
                          <p>No Affected URLs available for this vendor </p>
                        }
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Grid>
        </Grid>
      </Container>
      {selectedCVE && <Modal
        open={openCreateRemediation}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box sx={style} className="scroll-design">
          <div className="popup-remiadation">
            <div className="pop-flex-remiadation">
              <h3>Create Remediation</h3>
              <img src={CrossImg} style={{ cursor: 'pointer' }} alt="icon" onClick={handleCloseCreateRemediation} />
            </div>
            <form onSubmit={sendRemediation} fullWidth sx={{ mb: 3 }}>
              <div className="popup-form-remidaition">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {!selectedContactPerson ? "Select Contact Person" : ""}
                  </InputLabel>
                  <TextField
                    labelId="demo-simple-select-label"
                    select
                    defaultValue=""
                    value={selectedContactPerson || ""}
                    onChange={handleContactPersonChange}
                    sx={{ mb: 3 }}
                  >
                    {contactPersonList && contactPersonList.length >= 0 && contactPersonList.map((item) => (
                      <MenuItem key={item._id} value={JSON.stringify(item)}>
                        {item.firstName} {item.lastName} {`(${item.email})`}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
                <TextField
                  name="name"
                  label="Issue Name"
                  fullWidth
                  value={formValues.name}
                  onChange={handleChange}
                  sx={{ mb: 3 }}
                />
                <TextField
                  label="Description"
                  name="Description"
                  multiline
                  fullWidth
                  rows={3}
                  // maxRows={4}
                  sx={{ mb: 3 }}
                  value={formValues.description}
                  onChange={handleChange}
                />
                <TextField
                  label="Affected URLs"
                  name="URL"
                  fullWidth
                  multiline
                  rows={3}
                  sx={{ mb: 3 }}
                  value={formValues.url}
                  onChange={handleChange}
                />
                <TextField
                  label="Remediation Steps"
                  name="Remediation"
                  multiline
                  fullWidth
                  rows={3}
                  // maxRows={4}
                  sx={{ mb: 3 }}
                  value={formValues.remediation}
                  onChange={handleChange}
                />
                <TextField
                  name="deadline"
                  InputLabelProps={{ shrink: true, required: true }}
                  type="date"
                  label="Deadline"
                  className="deadline-input"
                  onChange={handleChange}
                  value={formValues.deadline}
                  inputProps={{
                    min: getCurrentDate(new Date()),
                    onKeyDown: (e) => e.preventDefault(),
                    style: {
                      WebkitAppearance: 'none', // Remove on Chrome/Safari/Edge
                      MozAppearance: 'textfield', // Remove on Firefox
                      appearance: 'none', // General appearance removal
                      position: 'relative',
                    },
                  }}
                  sx={{ color: "white", mb: 3 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {/* {/ Custom image for opening the date picker /} */}
                        <img
                          src={CalendarTodayIcon}
                          alt="calendar icon"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            document.getElementsByName('deadline')[0].showPicker();
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="Remark"
                  name="remark"
                  multiline
                  fullWidth
                  rows={3}
                  // maxRows={4}
                  value={formValues.remark}
                  onChange={handleChange}
                  sx={{ mb: 3 }}
                />
                <div className="button-alin-remaidation">
                  <Button onClick={handleCloseCreateRemediation} variant="contained" className="cancel-popup-btns">
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" className="cancel-popup-btns save-direct">
                    Save
                    {loading ? (
                      <CircularProgress size={12} sx={{ marginLeft: "15px" }} />
                    ) : null}
                  </Button>
                </div>

              </div>
            </form>
          </div>
        </Box>
      </Modal>}
    </>
  );
}

export default CVEDetail;
